import { useEffect } from 'react';
import { useSharedContext } from '../../pages/GTBCustomize/ContextProviders/SharedContext';
import { Timer } from '@fff-web/fff-utilities';

const useTimer = (startDate: Date | null) => {
  const { setTimerStatus } = useSharedContext();
  const timer = Timer.useTimer(startDate);

  useEffect(() => {
    if (timer.timeUp) {
      setTimerStatus('expired');
    }
  }, [timer.timeUp]);

  return timer;
};

export default useTimer;
